<template>
  <div>{{ $t('viewFreeZoneChildEstablishments') }}</div>
</template>
<script setup></script>
